/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IReports = DealerwareWebComponents.IReportsConfiguration
    import Languages = DealerwareWebComponents.Languages

    getDealerwareWebComponentsModule()
        .constant(
            'apiToGridMapContracts', {
                'status'                        : 'current_state',
                'service_advisor'               : 'service_advisor_name',
                'reservation_pickup'            : 'reservation_start_date_time',
                'reservation_dropoff'           : 'reservation_finish_date_time',
                'actual_reservation_pickup'     : 'actual_reservation_start_date_time',
                'actual_reservation_dropoff'    : 'actual_reservation_finish_date_time',
                'days'                          : 'reservation_duration_days',
                'fuel_exp'                      : 'fuel_expenses',
                'fuel_service_charge_exp'       : 'fuel_service_charge_expenses',
                'odometer_exp'                  : 'odometer_expenses',
                'toll_exp'                      : 'toll_expenses',
                'daily_rate_exp'                : 'daily_rate_expenses',
                'fuel_adj'                      : 'fuel_adjustments',
                'fuel_service_charge_adj'       : 'fuel_service_charge_adjustments',
                'odometer_adj'                  : 'odometer_adjustments',
                'toll_adj'                      : 'toll_adjustments',
                'daily_rate_adj'                : 'daily_rate_adjustments',
                'cleaning_adj'                  : 'cleaning_adjustments',
                'damage_adj'                    : 'damage_adjustments',
                'warranty_adj'                  : 'warranty_adjustments',
                'generic_adj'                   : 'generic_adjustments',
                'ticket_adj'                    : 'ticket_adjustments',
                'total_expenses_and_adjustments': 'total_adjustments',
                'debit_total'                   : 'charges_total',
                'credit_total'                  : 'credits_total',
                'tax_total'                     : 'taxes_total',
                'fee_facility'                  : 'fee_facility',
                'fee_rental_car_surcharge'      : 'fee_rental_car_surcharge',
                'fee_road_safety_program'       : 'fee_road_safety_program',
                'fee_transportation'            : 'fee_transportation',
                'fee_trip'                      : 'fee_trip',
                'fee_vehicle_license_recovery'  : 'fee_vehicle_license_recovery'
            }
        );

    export class ReportsContractsDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            'apiToGridMapContracts',
            'DealerwareContractCollection',
            '$dealerwareNotification',
            'DataUtils',
            '$state',
            '$filter',
            '$controller',
            'uiGridConstants',
            '$mobilityCompanyAuthentication',
            'ConvertUnits',
            '$dealerwareInternationalizationData',
            'i18nService',
        ];

        private reports                 : any = { };
        private gridColumns             : any;
        private numericTemplate         : any;
        public labels: {
            report?: any
        };
        public labelsUnformatted: {
            report?: any
        };

        private defaultGridSorts        : any = {
            sort_by         : 'reservation_pickup',
            sort_direction  : 'desc'
        };

        private configuration           : IReports;
        private isMetric: boolean;
        private GALLON_LABEL = 'gallons';
        private LITER_LABEL = 'L';
        private MILES_LABEL = 'miles';
        private KM_LABEL = 'km';

        constructor(
            private $scope: ng.IScope,
            private apiToGridMapContracts: any,
            private DealerwareContractCollection: any,
            private $dealerwareNotification: any,
            private DataUtils: any,
            private $state: any,
            private $filter: any,
            private $controller: any,
            private uiGridConstants: any,
            private $mobilityCompanyAuthentication: any,
            private ConvertUnits: any,
            public $dealerwareInternationalizationData: any,
            public i18nService: any
        ) {
            this.getLabels('contracts');
            this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.report.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.report.columnHeaders);
                    _self.initColumns();
                    _self.setReportsConfiguration();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public initColumns(): void {
            const _self = this;

            var filterHeaderHtml = '<div class="report-filter-button-container">'
                + '<md-button class="md-icon-button" style="margin: 0;" aria-label="Refresh" '
                + 'ng-click="col.colDef.showModal(this)">'
                + '<md-icon md-svg-icon="filter" class="icon-filter"></md-icon>'
                + '</md-button>'
                + '</div>';

            var numericTemplate = this.numericTemplate = 'dealerware-contracts-numeric-filter';

            this.gridColumns = [
                {
                    name            : 'Contract ID',
                    displayName     : _self.labels.report.columnHeaders.contract_id,
                    field           : 'confirmation_token',
                    renderHtml      : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.confirmation_token) ? '' :
                            '<a class="reports-contracts-table-cell-contract-id" href="' + _self.$state.href('root.private.application.contracts.details',
                            { contractId: this.reservation_id }
                            ) + '">' + this.confirmation_token + '</a>';
                    }
                },

                {
                    name            : 'Status',
                    displayName     : _self.labels.report.columnHeaders.status,
                    field           : 'current_state',
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.current_state) ? '' :
                            this.current_state === 'finished'    ? 'Finished' :
                            this.current_state === 'no_showed'   ? 'No Show' :
                            this.current_state === 'cancelled'   ? 'Canceled' : '';
                    },
                    filter: {
                        type: _self.uiGridConstants.filter.SELECT,
                        selectOptions: [
                            { value: 'finished',    label: 'Finished' },
                            { value: 'cancelled',   label: 'Canceled' },
                            { value: 'no_showed',   label: 'No Show' }
                        ]
                    }
                },

                {
                    name            : 'Customer Name',
                    displayName     : _self.labels.report.columnHeaders.customer_name,
                    field           : 'customer_name',
                    visible         : false,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.customer_name) ? '' :
                            '<a class="reports-contracts-table-cell-customer-name" href="' + _self.$state.href('root.private.application.customers.details',
                            { customerId: this.customer_id }
                            ) + '">' + this.customer_name + '</a>';
                    }
                },

                {
                    name            : 'Repair Order',
                    displayName     : _self.labels.report.columnHeaders.repair_order,
                    field           : 'repair_order',
                    visible         : true
                },

                {
                    name            : 'Service Advisor',
                    displayName     : _self.labels.report.columnHeaders.service_advisor,
                    field           : 'service_advisor_name',
                    renderHtml      : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.service_advisor_name) ? '' :
                            '<a class="reports-contracts-table-cell-service-advisor" href="' + _self.$state.href('root.private.application.employees.details',
                            { employeeId: this.service_advisor_id }
                            ) + '">' + this.service_advisor_name + '</a>';
                    }
                },

                {
                    name            : 'Created by',
                    displayName     : _self.labels.report.columnHeaders.created_by,
                    field           : 'created_by',
                    visible         : false
                },

                {
                    name            : 'Started by',
                    displayName     : _self.labels.report.columnHeaders.started_by,
                    field           : 'started_by',
                    visible         : false
                },

                {
                    name            : 'Finished by',
                    displayName     : _self.labels.report.columnHeaders.finished_by,
                    field           : 'finished_by',
                    visible         : false
                },

                {
                    name            : 'Scheduled Start',
                    displayName     : _self.labels.report.columnHeaders.scheduled_start,
                    field           : 'reservation_start_date_time',
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function () {
                        return this.reservation_pickup ?
                            _self.reports.dataUtils.formatDateSimple(this.reservation_pickup)
                            + ' ' + _self.reports.dataUtils.formatTimeSimple(this.reservation_pickup, _self.reports.timeZone)
                            + ' ' + _self.reports.timeZoneCode : '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Scheduled Start Time Zone',
                    displayName     : _self.labels.report.columnHeaders.scheduled_start_time_zone,
                    field           : 'reservation_start_date_time_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.reservation_pickup ? _self.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Scheduled Finish',
                    displayName     : _self.labels.report.columnHeaders.scheduled_finish,
                    field           : 'reservation_finish_date_time',
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function () {
                        return this.reservation_dropoff ?
                            _self.reports.dataUtils.formatDateSimple(this.reservation_dropoff)
                                + ' ' + _self.reports.dataUtils.formatTimeSimple(this.reservation_dropoff, _self.reports.timeZone)
                                + ' ' + _self.reports.timeZoneCode : '';
                    },
                    enableFiltering : false

                },

                {
                    name            : 'Scheduled Finish Time Zone',
                    displayName     : _self.labels.report.columnHeaders.scheduled_finish_time_zone,
                    field           : 'reservation_finish_date_time_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.reservation_dropoff ? _self.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Actual Start',
                    displayName     : _self.labels.report.columnHeaders.actual_start,
                    field           : 'actual_reservation_start_date_time',
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function () {
                        return this.actual_reservation_pickup ?
                            _self.reports.dataUtils.formatDateSimple(this.actual_reservation_pickup)
                                + ' ' + _self.reports.dataUtils.formatTimeSimple(this.actual_reservation_pickup, _self.reports.timeZone)
                                + ' ' + _self.reports.timeZoneCode : '';
                    },
                    enableFiltering : false

                },

                {
                    name            : 'Actual Start Time Zone',
                    displayName     : _self.labels.report.columnHeaders.actual_start_time_zone,
                    field           : 'actual_reservation_start_date_time_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.actual_reservation_pickup ? _self.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Actual Finish',
                    displayName     : _self.labels.report.columnHeaders.actual_finish,
                    field           : 'actual_reservation_finish_date_time',
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function () {
                        return this.actual_reservation_dropoff ?
                            _self.reports.dataUtils.formatDateSimple(this.actual_reservation_dropoff)
                                + ' ' + _self.reports.dataUtils.formatTimeSimple(this.actual_reservation_dropoff, _self.reports.timeZone)
                                + ' ' + _self.reports.timeZoneCode : '';
                    },
                    enableFiltering : false

                },

                {
                    name            : 'Actual Finish Time Zone',
                    displayName     : _self.labels.report.columnHeaders.actual_finish_time_zone,
                    field           : 'actual_reservation_finish_date_time_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.actual_reservation_dropoff ? _self.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Reservation Duration Days',
                    displayName     : _self.labels.report.columnHeaders.reservation_duration_days,
                    field           : 'reservation_duration_days',
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'gteq',
                                startRange  : 7
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'days';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'reservation_duration_days',
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Length of Contract',
                    displayName     : _self.labels.report.columnHeaders.length_of_contract,
                    field           : 'length_of_loan',
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            this.length_of_loan, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'length_of_loan');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Program Name',
                    displayName     : _self.labels.report.columnHeaders.vehicle_group_name,
                    field           : 'fleet_group_name',
                    visible         : true
                },

                {
                    name            : 'Additional Payer',
                    displayName     : _self.labels.report.columnHeaders.additional_payer_name,
                    field           : 'additional_payer_name',
                    visible         : true
                },

                {
                    name: 'Time to Return',
                    displayName     : _self.labels.report.columnHeaders.time_to_return,
                    field: 'minutes_to_return',
                    formatCallback: function() {
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            !this.minutes_to_return ? undefined : this.minutes_to_return / 60 / 24,
                            { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal: function(columnScope: any) {
                        _self.genericNumericModal.call(_self, columnScope, 'minutes_to_return');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    presentCallback : function () {

                        // Remove this column entirely if this isn't a DMS location.
                        //
                        return !!this.$auth.location.settings.dms_provider;
                    },

                },

                {
                    name            : 'VIN',
                    displayName     : _self.labels.report.columnHeaders.vin,
                    field           : 'vin',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.isBlank(this.vin) ? '' : this.vin;
                    },
                    width           : 175
                },

                {
                    name            : 'Stock #',
                    displayName     : _self.labels.report.columnHeaders.stock_number,
                    field           : 'stock_number',
                    visible         : false
                },

                {
                    name            : 'License Plate',
                    displayName     : _self.labels.report.columnHeaders.license_plate,
                    field           : 'license_plate',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.isBlank (this.license_plate) ? '' :
                            this.license_plate.toUpperCase();
                    },
                    cellClass       : 'ui-grid-cell-contents-text'
                },

                {
                    name            : `Start Fuel ${this.getFuelIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.start_fuel} ${this.getFuelIdentifier()}`,
                    field           : 'starting_fuel',
                    visible         : false,
                    formatCallback  : function () {
                        const startingFuel = _self.convertFuel(this.starting_fuel_in_liters);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            startingFuel, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'starting_fuel');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : `Finish Fuel ${this.getFuelIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.finish_fuel} ${this.getFuelIdentifier()}`,
                    field           : 'ending_fuel',
                    visible         : false,
                    formatCallback  : function () {
                        const endingFuel = _self.convertFuel(this.ending_fuel_in_liters);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            endingFuel, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'ending_fuel');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : `Fuel Difference ${this.getFuelIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.fuel_difference} ${this.getFuelIdentifier()}`,
                    field           : 'fuel_difference',
                    visible         : false,
                    formatCallback  : function () {
                        const startingFuel = _self.convertFuel(this.starting_fuel_in_liters);
                        const endingFuel = _self.convertFuel(this.ending_fuel_in_liters);
                        const fuelDifference = (startingFuel - endingFuel);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            fuelDifference, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'fuel_difference');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : `Start Mileage ${_self.getMileageIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.start_mileage} ${_self.getMileageIdentifier()}`,
                    field           : 'starting_mileage',
                    visible         : false,
                    formatCallback  : function () {
                        const startingMileage = _self.convertMileage(this.starting_mileage_in_km);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            startingMileage, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'starting_mileage');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : `Finish Mileage ${_self.getMileageIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.finish_mileage} ${_self.getMileageIdentifier()}`,
                    field           : 'ending_mileage',
                    visible         : false,
                    formatCallback  : function () {
                        const endingMileage = _self.convertMileage(this.ending_mileage_in_km);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            endingMileage, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'ending_mileage');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : `Mileage Difference ${_self.getMileageIdentifier()}`,
                    displayName     : `${_self.labels.report.columnHeaders.mileage_difference} ${_self.getMileageIdentifier()}`,
                    field           : 'mileage_difference',
                    visible         : false,
                    formatCallback  : function () {
                        const startingMileage = _self.convertMileage(this.starting_mileage_in_km);
                        const endingMileage = _self.convertMileage(this.ending_mileage_in_km);
                        const mileageDifference = (startingMileage - endingMileage);
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            mileageDifference, { decimalPlaces: 2, forceZeroPadDecimals: true }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'mileage_difference');
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Mileage Expenses',
                    displayName     : _self.labels.report.columnHeaders.mileage_expenses,
                    field           : 'odometer_expenses',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.odometer_expenses);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'odometer_exp', 'odometer_expenses');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Fuel Expenses',
                    displayName     : _self.labels.report.columnHeaders.fuel_expenses,
                    field           : 'fuel_expenses',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fuel_expenses);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'fuel_exp', 'fuel_expenses');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Fuel Service Charge Expenses',
                    displayName     : _self.labels.report.columnHeaders.fuel_service_charge_expenses,
                    field           : 'fuel_service_charge_expenses',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fuel_service_charge_expenses);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'fuel_service_charge_exp', 'fuel_service_charge_expenses');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Toll Expenses',
                    displayName     : _self.labels.report.columnHeaders.toll_expenses,
                    field           : 'toll_expenses',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.toll_expenses);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'toll_exp', 'toll_expenses');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Daily Rate Expenses',
                    displayName     : _self.labels.report.columnHeaders.daily_rate_expenses,
                    field           : 'daily_rate_expenses',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.daily_rate_expenses);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'daily_rate_exp', 'daily_rate_expenses');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Mileage Adjustments',
                    displayName     : _self.labels.report.columnHeaders.mileage_adjustments,
                    field           : 'odometer_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.odometer_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'odometer_adj', 'odometer_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Fuel Adjustments',
                    displayName     : _self.labels.report.columnHeaders.fuel_adjustments,
                    field           : 'fuel_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fuel_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'fuel_adj', 'fuel_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Fuel Service Charge Adjustments',
                    displayName     : _self.labels.report.columnHeaders.fuel_service_charge_adjustments,
                    field           : 'fuel_service_charge_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fuel_service_charge_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'fuel_service_charge_adj', 'fuel_service_charge_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Toll Adjustments',
                    displayName     : _self.labels.report.columnHeaders.toll_adjustments,
                    field           : 'toll_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.toll_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'toll_adj', 'toll_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Daily Rate Adjustments',
                    displayName     : _self.labels.report.columnHeaders.daily_rate_expenses,
                    field           : 'daily_rate_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.daily_rate_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'daily_rate_adj', 'daily_rate_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Cleaning Adjustments',
                    displayName     : _self.labels.report.columnHeaders.cleaning_adjustments,
                    field           : 'cleaning_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.cleaning_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'cleaning_adj', 'cleaning_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Damage Adjustments',
                    displayName     : _self.labels.report.columnHeaders.damage_adjustments,
                    field           : 'damage_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.damage_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'damage_adj', 'damage_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Warranty Adjustments',
                    displayName     : _self.labels.report.columnHeaders.warranty_adjustments,
                    field           : 'warranty_adjustments',
                    visible         : false,
                    formatCallback  : function() {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.warranty_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function(columnScope: any) {
                        _self.genericNumericModal.call(_self, columnScope, 'warranty_adj', 'warranty_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Other Adjustments',
                    displayName     : _self.labels.report.columnHeaders.other_adjustments,
                    field           : 'generic_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.generic_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'generic_adj', 'generic_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Ticket Adjustments',
                    displayName     : _self.labels.report.columnHeaders.ticket_adjustments,
                    field           : 'ticket_adjustments',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.ticket_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (_self, columnScope, 'ticket_adj', 'ticket_adjustments');
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Total',
                    displayName     : _self.labels.report.columnHeaders.total,
                    field           : 'total_adjustments',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.total_adjustments);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (
                            _self, columnScope, 'total_expenses_and_adjustments', 'total_adjustments'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Total Charge Amount',
                    displayName     : _self.labels.report.columnHeaders.total_charge_amount,
                    field           : 'charges_total',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.charges_total);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (
                            _self, columnScope, 'debit_total', 'charges_total'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Total Credit Amount',
                    displayName     : _self.labels.report.columnHeaders.total_credit_amount,
                    field           : 'credits_total',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.credits_total);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (
                            _self, columnScope, 'credit_total', 'credits_total'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Tax Amount',
                    displayName     : _self.labels.report.columnHeaders.tax_amount,
                    field           : 'taxes_total',
                    formatCallback  : function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.taxes_total);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        _self.genericNumericModal.call (
                            _self, columnScope, 'tax_total', 'taxes_total'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass       : 'ui-grid-cell-contents-number'
                },
                {
                    name: 'Facility Fee',
                    displayName     : _self.labels.report.columnHeaders.facility_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_facility',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_facility);
                    },
                    visible: false
                },
                {
                    name: 'Rental Fee',
                    displayName     : _self.labels.report.columnHeaders.rental_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_rental_car_surcharge',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_rental_car_surcharge);
                    },
                    visible: false
                },
                {
                    name: 'Road Safety Fee',
                    displayName     : _self.labels.report.columnHeaders.road_safety_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_road_safety_program',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_road_safety_program);
                    },
                    visible: false
                },
                {
                    name: 'Transportation Fee',
                    displayName     : _self.labels.report.columnHeaders.transportation_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_transportation',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_transportation);
                    },
                    visible: false
                },
                {
                    name: 'Trip Fee',
                    displayName     : _self.labels.report.columnHeaders.trip_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_trip',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_trip);
                    },
                    visible: false
                },
                {
                    name: 'Recovery Fee',
                    displayName     : _self.labels.report.columnHeaders.recovery_fee,
                    cellClass: 'ui-grid-cell-contents-number',
                    enableFiltering: false,
                    field: 'fee_vehicle_license_recovery',
                    formatCallback: function () {
                        return _self.$dealerwareInternationalizationData.getCurrencyLabel(this.fee_vehicle_license_recovery);
                    },
                    visible: false
                }
            ];
        }

        private getMileageIdentifier(): string {
            const label = this.isMetric
                ? this.KM_LABEL
                : this.MILES_LABEL;
            return `(${label})`;
        }

        private getFuelIdentifier(): string {
            const label = this.isMetric
              ? this.LITER_LABEL
              : this.GALLON_LABEL;
            return `(${label})`;
        }

        private convertMileage(km): number {
            return this.isMetric
                ? km
                : this.ConvertUnits.kmToMiles(km);
        }

        private convertFuel(liters): number {
            const convertedValue = this.isMetric
              ? liters
              : this.ConvertUnits.litersToGallons(liters);
            return convertedValue;
        }

        public genericNumericModal ( columnScope: any, apiField: string, columnField?: string ) : void {

            var _self = this;

            columnField = columnField || apiField;

            if (! columnScope.col.modalData) {
                columnScope.col.modalData = {
                    type        : 'gteq',
                    startRange  : 10
                };
            }

            columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

            var filterField = apiField;

            _self.reports.setFilterControlData(filterField, {
                title                   : columnScope.col.name,
                field                   : columnField,
                template                : _self.numericTemplate,
                gridColumn              : columnScope.col,
                calculateFilterFunction : _self.reports.calculateNumericFilter
            });

            _self.reports.showFilterModal(filterField);
        }

        public loadAllDataForExport ( ) : ng.IPromise<any> {
            return this.reports.loadAllDataForExport();
        }

        public setReportsConfiguration () : void {

            var that = this;

            // This report's configuration.
            //
            this.configuration = {
                grid        : {
                    defaultSorts    : this.defaultGridSorts,
                    defaultFilters  : {},
                    columnMap       : this.apiToGridMapContracts,
                    columns         : this.gridColumns
                },
                collection  : {
                    model           : this.DealerwareContractCollection,
                    loadMethod      : 'contracts'
                },
                $scope              : this.$scope
            };

            // Add base controller members to this report.
            //
            this.reports = this.$controller('ReportsController', {
                thisReportConfiguration : this.configuration,
                '$scope'                : this.$scope
            });

            // CSV config uses bases ReportsController methods for dataLoading,
            // but they could be custom for this report.
            //
            var exportFileName = 'contracts_' + moment().format('YYYY_MM_DD') + '.csv';
            this.configuration.csvExport = {
                showExporterMenu    : false,
                thisPage    : {
                    fileName        : exportFileName,
                    dataLoadMethod  : this.reports.loadThisPageDataForExport
                },
                allPages    : {
                    fileName        : exportFileName,

                    dataLoadMethod  : ( ) => {
                        return this.loadAllDataForExport.call (that);
                    },

                    sort: {
                        by         : 'reservation_pickup',
                        direction  : 'desc'
                    }
                }
            };

            // Update the export filename to add location name after the location has loaded
            //
            var cancelExportedCsvFileNameWatcher = this.$scope.$watch(() => {
                return this.reports.locationName;
            }, (locationName: string) => {
                if (locationName) {
                    this.setExportedCsvFileName();
                    cancelExportedCsvFileNameWatcher();
                }
            });
        }

        public setExportedCsvFileName () : void {
            if (this.reports.locationName) {
                var exportFileNamePrefix = this.$filter('spaceless')(this.reports.locationName.toLowerCase());

                var currentFilename = this.configuration.csvExport.thisPage.fileName;
                this.configuration.csvExport.thisPage.fileName = exportFileNamePrefix + '_' + currentFilename;
                this.configuration.csvExport.allPages.fileName = exportFileNamePrefix + '_' + currentFilename;
            }
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsContractsDirectiveController',
        ReportsContractsDirectiveController
    );


    export class ReportsContractsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ReportsContractsDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/reports/contracts/contracts-directive.html';
        public scope            : Object    =   { };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareReportsContracts',
        ( ) => new ReportsContractsDirective()
    );

}
